import type { JSX } from "react";

export const useBranchNavigation = (
  getStepForm: (stepId: number) => JSX.Element,
  router?: { getCurrentStep: () => number }
) => {
  const names = ["Details", "Business hours", "Vibes", "Amenities", "Media"];

  // Get current step from router (which extracts from pathname)
  const currentStep = router?.getCurrentStep() ?? 1;
  const activeId = currentStep >= 1 && currentStep <= 5 ? currentStep : 1;

  const stepsBase = Array.from({ length: 5 }, (_, i) => ({
    id: i + 1,
    name: names[i],
    form: getStepForm(i + 1),
  }));

  // Generate navigation list based on active step
  const navigationList = stepsBase.map(step => ({
    ...step,
    done: step.id < activeId,
    active: step.id === activeId,
  }));

  const activeStep = navigationList.find(step => step.active);

  return { navigationList, activeStep, activeId };
};
